import { Component, h, Prop } from '@stencil/core';

declare const assetPath;

@Component({
    tag: 'app-article',
    styleUrl: 'app-article.scss'
})
export class AppArticle {

    @Prop() photoSrc: string;
    @Prop() photoSrcWebp: string;
    @Prop() photoAlt: string;
    @Prop() articleTitle: string;
    @Prop() articleCategories: string;
    @Prop() summary: string;
    @Prop() ctaText: string;
    @Prop() ctaLink: string;
    @Prop() author: string;



    render() {
        return (
            <div class="article-card">
                <div class="mobile-wrapper">

                    <div class="card-image">
                        <app-lazy-img img-alt={this.photoAlt ? this.photoAlt : 'Quotient Sciences Logo'} img-src={this.photoSrc ? this.photoSrc : `${assetPath}/images/blog-news-default-image.png`} img-src-webp={this.photoSrcWebp} ></app-lazy-img>
                    </div>
                    <div class="mobile-right">
                        {this.articleCategories && this.articleCategories !== 'null' &&
                            <span class="tags">
                                {JSON.parse(this.articleCategories).join(', ')}
                            </span>
                        }
                        <a href={this.ctaLink} class="card-title">{this.articleTitle}</a>
                        {this.author &&
                            <span class='author'>By: {this.author}</span>
                        }
                    </div>
                </div>
                <div class="card-content">
                    <div class="desktop-right">
                        {this.articleCategories && this.articleCategories !== 'null' &&
                            <span class="tags">
                                {JSON.parse(this.articleCategories).join(', ')}
                            </span>
                        }
                        <a href={this.ctaLink} class="card-title">{this.articleTitle}</a>
                        {this.author &&
                            <span class='author'>By: {this.author}</span>
                        }
                    </div>

                    {this.summary &&
                        <p>{this.summary.length > 240 ? `${this.summary.substring(0, 240)}...` : this.summary}</p>
                    }
                    {this.ctaText &&
                        <a href={this.ctaLink} class='arrow-link__underline'>{this.ctaText} <svg>
                            <use href="/themes/custom/qsci/frontend/www/assets/icon/sheets/icons.svg#arrow-right"></use>
                        </svg></a>
                    }
                </div>
            </div>
        );
    }
}
